<template>
  <div class="dimed wrap">
    <div class="layer no-line-height">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Allergy.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Allergy.msg2') }}</div>
      </div>
      <div class="layer__body mb40">
        <div class="lst-buttons">
          <template v-for="allergy in allergys">
            <button
              :class="{on: allergySelectedList2.includes(allergy.COMM_CD)}"
              class="btn btn--line btn-anim"
              @mouseup="
                allergyChange(allergy.COMM_CD);
                $logInfo(`Allergy Check COMM_CD : ${allergy.COMM_CD}`);
              "
            >
              {{ allergy.COMM_CD_NM }}
            </button>
          </template>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('closeAllergy')">{{ $t('Modal.Allergy.msg3') }}</button>
        <button class="btn btn--submit btn-anim" @mouseup="$emit('setAllergy', allergySelectedList2)">{{ $t('Modal.Allergy.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'allergy',
  data() {
    return {
      allergys: this.$store.getters.getAllergys,
      allergySelectedList2: [],
    };
  },
  props: {
    allergySelectedList: Array,
  },
  methods: {
    allergyChange(alg) {
      if (this.allergySelectedList2.includes(alg)) {
        for (var i = 0; i < this.allergySelectedList2.length; ++i) {
          if (this.allergySelectedList2[i] === alg) {
            this.allergySelectedList2.splice(i, 1);
            break;
          }
        }
      } else {
        this.allergySelectedList2.push(alg);
      }
    },
  },
  mounted() {
    this.allergySelectedList2 = _.cloneDeep(this.allergySelectedList);
    if (this.$i18n.locale == 'jp') {
      this.allergys.forEach((item) => {
        item.COMM_CD_NM = item.COMM_CD_JP_NM;
      });
    } else if (this.$i18n.locale == 'ko') {
      this.allergys.forEach((item) => {
        item.COMM_CD_NM = item.COMM_CD_KO_NM;
      });
    } else if (this.$i18n.locale == 'en') {
      this.allergys.forEach((item) => {
        item.COMM_CD_NM = item.COMM_CD_EN_NM;
      });
    } else if (this.$i18n.locale == 'cn') {
      this.allergys.forEach((item) => {
        item.COMM_CD_NM = item.COMM_CD_CN_NM;
      });
    } else if (this.$i18n.locale == 'tw') {
      this.allergys.forEach((item) => {
        item.COMM_CD_NM = item.COMM_CD_TW_NM;
      });
    }
  },
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style src='@/assets/css/user/dark/common-dark.css' scoped></style>
<style scoped>
.mb40 {
  margin: 0px 0px 40px 0px;
}

.no-line-height {
  line-height: 0.3em;
}

.lyr-txt {
  line-height: 1.6em;
}

.lst-buttons {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.lst-buttons button {
  width: 18.5vw;
  height: 5.5vh;
  margin: 2.2vw 2.2vw 0px 0px;
}

.lst-buttons button:nth-child(3n) {
  margin-right: 0px;
}

.lst-buttons button.on {
  background-color: var(--secondary-color);
  color: #ffffff;
}

.dark .btn--line.on {
  background-color: #fff;
  color: #000;
}
</style>
